import React, { useEffect } from "react";
import Button from "components/Elements/Button/Button.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import AddSubUserCompleteModal from "./AddSubUserCompleteModal.js";
import encodeTags from "utils/encodeTagsFunc.ts";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { SubUserMultipleInput } from "./SubUserMultipleInput.js";
import { useState } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useProfile } from "contexts/profileContext/profileContext.js";

import "./AddSubUserModal.scss";

const AddSubUserLink = () => {
  const { getTextByKey } = useContent();
  const { closeModal, setModal } = useModal();

  const [newSubUserList, setNewSubUserList] = useState([]);
  const [newSubUserMessage, setNewSubUserMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { getSubUserData, setSubUsers, setNumberOfUsers } = useProfile();
  const [loading, setLoading] = useState(false);

  const currentPage = getSubUserData().currentPage;
  const orderAscending = getSubUserData().orderAscending;
  const fieldToOrder = getSubUserData().fieldToOrder;
  const sizeNumber = getSubUserData().sizeNumber;

  const { getUserData, setUserData } = useUser();

  const handleChangeMessage = (e) => {
    setNewSubUserMessage(e.target.value);
  };

  const addSubUser = async () => {
    if (newSubUserList.length === 0) {
      setErrorMessage(getTextByKey("add-sub-user-email-error"));
      return;
    }

    const parameters = {
      subUserEmails: newSubUserList,
      page: currentPage,
      size: sizeNumber,
      field: fieldToOrder,
      orderAsc: orderAscending,
      newSubUserMessage: encodeTags(newSubUserMessage),
      isAdminSubUser: getUserData().IsAdminSubUser,
    };

    setLoading(true);
    const response = await apiRequest(
      "SubUsers",
      "ReactAddSubUser",
      parameters,
      "POST"
    );

    if (response.status === "success") {
      setErrorMessage("");
      if (response.data) {
        setSubUsers(response.data.userList);
        setNumberOfUsers(response.data.userAmount);
        setLoading(false);

        // clone getUserData into newUserData
        let newUserData = {
          ...getUserData(),
          UserAvailableSubUsersLicenses:
            getUserData().UserAvailableSubUsersLicenses - newSubUserList.length,
        };
        newUserData.UserAvailableSubUsersLicenses =
          getUserData().UserAvailableSubUsersLicenses - newSubUserList.length;
        setUserData(newUserData);

        setModal({
          modal: AddSubUserCompleteModal,
        });
      } else {
        setSubUsers([]);
        setNumberOfUsers(0);
        setLoading(false);
      }
    } else {
      setErrorMessage(getTextByKey(response.data));
      setLoading(false);
    }
  };

  useEffect(() => {
    if (newSubUserList.length > 0) {
      setErrorMessage("");
    }
  }, [newSubUserList]);

  return (
    <>
      {
        <div className="insert-new-user-modal">
          <SubUserMultipleInput
            mailsList={newSubUserList}
            setMailsList={setNewSubUserList}
            tooltipText={getTextByKey("myprofile-add-new-sub-user-tooltip")}
            errorMessage={errorMessage}
            UserAvailableSubUsersLicenses={
              getUserData().UserAvailableSubUsersLicenses
            }
          />
          <div className="sub-title-for-input">
            {getTextByKey("add-sub-user-text")}
          </div>
          <textarea onChange={handleChangeMessage}></textarea>
          {loading ? (
            <div className="sub-user-loading">
              <LoadingImageElement />
            </div>
          ) : (
            <Button className="new-button" onClick={() => addSubUser()}>
              {getTextByKey("add-sub-user")}
            </Button>
          )}
        </div>
      }
    </>
  );
};

export default AddSubUserLink;
